import React from "react";
import CartStore from "../../stores/CartStore";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { CustomComponent, EcommerceEvent } from "../../models/Event";
import { observer } from "mobx-react-lite";

type Props = {
    eventList: EcommerceEvent;
    template: CustomComponent;
    cartStore: CartStore;
};

const CustomEventList = observer(
    ({ eventList, template, cartStore }: Props) => {
        const componentMap = {
            Box: ({ children, ...props }: any) => (
                <Box {...props}>{children}</Box>
            ),
            Grid: ({ children, ...props }: any) => (
                <Grid container {...props}>
                    {children}
                </Grid>
            ),
            GridItem: ({ children, ...props }: any) => (
                <Grid item {...props}>
                    {children}
                </Grid>
            ),
            Button: ({ children, ...props }: any) => (
                <Button {...props}>{children}</Button>
            ),
            Text: observer(({ children, departmentId, ...props }: any) => (
                <Typography {...props}>
                    {departmentId
                        ? cartStore.getDepartmentQuantity(departmentId, false)
                        : children}
                </Typography>
            )),
            Image: ({ src, alt, ...props }: any) => (
                <img src={src} alt={alt} {...props} />
            ),
            Divider: ({ ...props }: any) => <Divider {...props} />,
            RawHTML: ({ html, ...props }: any) => (
                <Box dangerouslySetInnerHTML={{ __html: html }} {...props} />
            ),
            AddDepartmentToCartButton: ({
                departmentId,
                label,
                ...props
            }: {
                departmentId: number;
                label: string;
            }) => {
                const handleAddDepartmentToCart = () => {
                    cartStore.incrementGaQuantity(departmentId);
                };

                return (
                    <Button onClick={handleAddDepartmentToCart} {...props}>
                        {label}
                    </Button>
                );
            },
            RemoveDepartmentFromCartButton: ({
                departmentId,
                label,
                ...props
            }: {
                departmentId: number;
                label: string;
            }) => {
                const handleRemoveDepartmentFromCart = () => {
                    cartStore.decrementGaQuantity(departmentId);
                };

                return (
                    <Button onClick={handleRemoveDepartmentFromCart} {...props}>
                        {label}
                    </Button>
                );
            },
        };

        function renderComponent(component: CustomComponent): React.ReactNode {
            const { type, props, children } = component;

            // if (props.authRequired && !)

            const ComponentRenderer =
                componentMap[type] ||
                (() => <div>Unknown component type: {type}</div>);

            let renderedChildren: React.ReactNode = null;

            if (Array.isArray(children)) {
                renderedChildren = children.map((child, index) =>
                    typeof child === "object" ? (
                        renderComponent(child)
                    ) : (
                        <React.Fragment key={index}>{child}</React.Fragment>
                    ),
                );
            } else if (
                typeof children === "string" ||
                typeof children === "number"
            ) {
                renderedChildren = children;
            }

            return (
                <ComponentRenderer {...props}>
                    {renderedChildren}
                </ComponentRenderer>
            );
        }

        return <>{renderComponent(template)}</>;
    },
);

export default CustomEventList;
